import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { AlbumResponse } from '@klubovna/api-client';
import { TranslateModule } from '@ngx-translate/core';
import { LazyBgLoaderDirective } from '@shared';

@Component({
  selector: 'k-album-card',
  standalone: true,
  imports: [ LazyBgLoaderDirective, TranslateModule ],
  templateUrl: './album-card.component.html',
  styleUrl: './album-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlbumCardComponent {
  album = input.required<AlbumResponse>();
  language = input<'sk' | 'en'>('sk');

  cardClick = output<AlbumResponse>();

  onClick(): void {
    this.cardClick.emit(this.album());
  }

  titlePhotoUrl = computed(() => {
    return this.album().titlePhoto?.path || '/images/space.png';
  });

  albumName = computed(() => {
    return this.album().name[this.language()];
  });

  albumDescription = computed(() => {
    return this.album().description[this.language()];
  });

  photoCount = computed(() => {
    return this.album().photos?.length || 0;
  });
}
